// config/api-endpoints.js
export const LIST_ENDPOINTS = {
  tasks: '/tasks',
  persons: '/persons',
  

  // User Management
  userPermissions: '/user/permissions',
  userRoles: '/user/roles',
  users: '/users',
  
  // Budget
  budgetItems: '/budget/items',
  
  // Parameters
  parametersHr: '/parameters/hr',
  parametersNotification: '/parameters/notification',
  parametersTicket: '/parameters/ticket',
  parametersUser: '/parameters/user',
  parametersPost: '/parameters/post',
  parametersWorkflow: '/parameters/workflow',
  parametersMeeting: '/parameters/meeting',
  parametersDocument: '/parameters/document',
  
  // Settings
  settings: '/settings',
  
  
  // Attributes
  attributes: '/attributes',
  
  // Groups
  groups: '/groups',
  
  // Knowledge
  knowledges: '/knowledges',
  
  // Report Attribute Maps
  reportAttributeMaps: '/report-attribute-maps',
  reportAttributeMapDetail: '/report-attribute-maps/{id}',
  
  // Partners
  partners: '/partners',
  
  // Template Types
  templateTypes: '/template/types',
  
  // Template Blocs
  templateBlocs: '/template/blocs',
  
  // Templates
  templates: '/templates',
  
  // Denunciation Categories
  denunciationCategories: '/denunciation/categories',
  
  // Document - File Types
  documentFileTypes: '/document/file_types',
  
  // Document - Folder Groups
  documentFolderGroup: '/document/folders/group/{id}',
  
  // Document - Folders
  documentFolders: '/document/folders',
  
  // Document - Keywords
  documentKeywords: '/document/keywords',
  
  // Document - Categories
  documentCategories: '/document/categories',
  
  // Note: Les endpoints suivants sont mentionnés dans les tags mais non documentés dans les paths :
  Institutions: '/institutions',
  InstitutionTypes: '/institution/types',
  Meetings: '/meetings',
  // - Meeting Participant
  // - Meeting Attachment
  Posts: '/posts',
  // - Post (Publication) Attachment
  // - Workflow Node
  // - Workflow Action
  // - Workflow Transition
  // - Workflow Task
  WorkflowInstances: '/workflows/instances',
  Workflows: '/workflows',
  // - Person Address
  // - Person Contact
  // - Person Attachment
  // - Event Type
  // - Sanction Type
  Structures: '/hr/structures',
  // - Employee Family
  // - Employee Career
  // - Employee Attachment
  Employees: '/hr/employees',
  // - Mission Type
  // - Inactivity Type
  Formation_Type: '/hr/formation/types',
  // - Departure Type
  // - Movement Type
  Status: '/hr/status',
  Grades: '/hr/grades',
  Diplomas: '/hr/diplomas',
  Professions: '/hr/professions',
  Job_ategories: '/hr/job_categories',
  Hierarchies: '/hr/hierarchies',
  Echelons: '/hr/echelons',
  Jobs: '/hr/jobs',
  Leave_Types: '/hr/leave/types',
  // - Holiday
  // - Support Type
  // - Category (Product)
  TicketCategories: '/ticket/categories',
  Tickets: '/tickets',
  // - Ticket Assignment
  // - Ticket Task
  // - Ticket Response
  // - Ticket Additional User
  // - Ticket Validation
  // - Helper (API)
  // - Document Group
  // - Document (Version)
  // - Document (Indexer)
  // - Document (Search)
  // - Document (File)
};

export const EXCLUDED_ENDPOINTS = [
  
  // Ajoutez les endpoints à exclure
];